import axios from 'axios';
import { API } from '@/App';

export const trackClick = (linkType, destination) => {
  axios.post(`${API}/track/click`, { link_type: linkType, destination }, { withCredentials: true }).catch(() => {});
};
